// CRC Search Infinite Scroll (sentinel-based)
(function () {
  const S = (window.__crcInf ||= { seen:new Set(), observer:null, booted:false });

  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const container=()=>$('#ProductGridContainer')||document;
  const grid=()=>$('#product-grid');
  const nextA=(r=document)=>$('#crc-next',r);
  const sentinel=()=>$('#crc-sentinel');

  function ensureSentinel(after){
    let s = sentinel();
    if (!s) {
      s = document.createElement('div');
      s.id = 'crc-sentinel';
      s.setAttribute('aria-hidden','true');
      s.style.cssText = 'height:1px;width:100%;opacity:0;pointer-events:none;margin:1px 0;';
      (after?.parentNode || container()).insertBefore(s, after?.nextSibling || null);
    }
    return s;
  }

  function seedSeen(){
    $$('.grid__item', grid()).forEach(c=>{
      const href=$('a[href]',c)?.href;
      if (href) S.seen.add(href);
    });
  }

  function dedupe(nodes){
    const out=[]; for(const n of nodes){
      const key=$('a[href]',n)?.href||n.dataset.productId||n.outerHTML.slice(0,200);
      if(!S.seen.has(key)){ S.seen.add(key); out.push(n); }
    } return out;
  }

  async function fetchNext(url){
    const res=await fetch(url,{credentials:'same-origin'});
    const html=await res.text();
    return new DOMParser().parseFromString(html,'text/html');
  }

  let loading=false;
  async function loadMore(){
    if(loading) return; loading=true;
    const a=nextA(); if(!a) return done();
    const g=grid(); if(!g) return done();
    addSpinner(a);
    try{
      const doc=await fetchNext(a.href);
      const newGrid=$('#product-grid',doc);
      const items=newGrid?$$('.grid__item',newGrid):[];
      dedupe(items).forEach(el=>g.appendChild(el));
      const newer=nextA(doc);
      a.replaceWith(newer||document.createComment('no more'));
      ensureSentinel(newer || g); // keep sentinel placed after the pagination/next marker
      if(!newer) done();
    }catch(e){ console.warn('[CRC∞] fetch failed',e); done(); }
    finally{ removeSpinner(); loading=false; }
  }

  function addSpinner(after){
    if(document.getElementById('crc-spinner')) return;
    const s=document.createElement('div'); s.id='crc-spinner';
    s.style.cssText='width:36px;height:36px;margin:16px auto;border-radius:50%;border:3px solid currentColor;border-top-color:transparent;animation:crc-spin .8s linear infinite;opacity:.25';
    (after?.parentNode||container()).insertBefore(s,after?.nextSibling||null);
    if(!document.getElementById('crc-spin-style')){
      const st=document.createElement('style'); st.id='crc-spin-style';
      st.textContent='@keyframes crc-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }
  }
  function removeSpinner(){ document.getElementById('crc-spinner')?.remove(); }

  function showEnd(){
    if(document.getElementById('crc-endmsg')) return;
    const d=document.createElement('div'); d.id='crc-endmsg';
    d.style.cssText='text-align:center;margin:16px 0;opacity:.7;font-size:.9rem';
    d.textContent='No more results.'; container().appendChild(d);
  }

  function done(){ S.observer?.disconnect(); S.observer=null; showEnd(); }

  function armObserver(){
    const a=nextA(); if(!a) return;
    const s=ensureSentinel(a);
    if('IntersectionObserver' in window){
      S.observer?.disconnect();
      S.observer=new IntersectionObserver(es=>{
        if(es.some(e=>e.isIntersecting)) loadMore();
      },{rootMargin:'800px 0px 800px 0px'});
      S.observer.observe(s);
    } else {
      // Fallback: click-to-load button
      if(!document.getElementById('crc-loadmore')){
        const wrap=document.createElement('div'); wrap.style.textAlign='center';
        const b=document.createElement('button'); b.id='crc-loadmore'; b.type='button';
        b.textContent='Load more results'; b.addEventListener('click',loadMore);
        wrap.appendChild(b); s.parentNode.insertBefore(wrap, s.nextSibling);
      }
    }
  }

  function boot(){ if(S.booted) return; S.booted=true; seedSeen(); armObserver(); }
  function rearm(){ S.booted=false; S.observer?.disconnect(); S.observer=null; S.seen.clear(); boot(); }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', rearm);
  document.addEventListener('shopify:section:reorder', rearm);
  document.addEventListener('collection:updated', rearm); // facets.js
})();
